import axios from 'axios'
import BpmOsgpoModule from '@/helpers/Modules/Product/BpmOsgpoModule'
import DateHelper from '@/helpers/DateHelper'

function defaultTreatyDate () {
  return DateHelper.addDays(DateHelper.todayIso(), 1)
}

function replacePolicyObject (target, source) {
  Object.keys(target).forEach(key => {
    delete target[key]
  })
  Object.assign(target, source)
}

export default {
  state: {
    policy: BpmOsgpoModule.Policy.empty(defaultTreatyDate()),
    isDraftSaved: false,
  },
  getters: {
    bpmPolicy (state) {
      return state.policy
    },
    bpmWizardStep (state) {
      const step = Number(state.policy?.wizardStep)
      return Number.isFinite(step) ? step : 0
    },
    bpmActiveProcessesByType (state) {
      const result = { 1: [], 2: [], 3: [] }
      const processes = state.policy?.business_process
      if (!Array.isArray(processes)) {
        return result
      }
      for (const item of processes) {
        if (result[item.type] && BpmOsgpoModule.BusinessProcess.isActive(item)) {
          result[item.type].push(item)
        }
      }
      return result
    },
  },
  mutations: {
    replaceBpmPolicy (state, policy) {
      replacePolicyObject(state.policy, policy)
    },
    resetBpmWizard (state, { treatyDate }) {
      replacePolicyObject(
        state.policy,
        BpmOsgpoModule.Policy.empty(treatyDate ?? defaultTreatyDate()),
      )
      state.isDraftSaved = false
    },
    setBpmDraftSaved (state, value) {
      state.isDraftSaved = value
    },
  },
  actions: {
    bpmSaveDraft ({ state, commit }, { mode, route, notify }) {
      if (!mode.shouldSaveDraft(state.policy)) {
        return
      }
      if (!state.policy.insurer) {
        return
      }
      return axios.post('/api/draft/save', { policy: state.policy })
        .then(res => {
          state.policy.number = res.data
          if (!state.isDraftSaved && route.query.draft !== res.data) {
            commit('setBpmDraftSaved', true)
            notify.success(
              { message: 'Черновик сохранен под номером ' + res.data, title: 'Сохранено' },
              { duration: 1000 },
            )
          }
          const query = { ...route.query, draft: res.data }
          const search = new URLSearchParams(query).toString()
          const url = window.location.pathname + (search ? '?' + search : '') + (window.location.hash || '')
          window.history.replaceState(window.history.state, '', url)
        })
        .catch(err => {
          notify.error(err)
        })
    },
    bpmLoadDraft (context, { draftId }) {
      return axios.get('/api/draft/item/' + draftId + '/' + BpmOsgpoModule.PRODUCT)
        .then(res => res.data)
    },
    bpmResetWizard ({ commit }, { treatyDate }) {
      commit('resetBpmWizard', { treatyDate })
    },
  },
}
